import { CallAPI } from "../utils/api";

export async function AddNotePaper(note) {
  const data = {
    note: note,
  };
  return CallAPI(
    `/addNotePaper`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
    true
  );
}

export async function GetNotePapers() {
  return CallAPI(
    `/getNotePapers`,
    {
      method: "GET",
    },
    true
  );
}

export async function DeleteNotePaper(notePaperId) {
  return CallAPI(
    `/deleteNotePaper/${notePaperId}`,
    {
      method: "DELETE",
    },
    true
  );
}


// export async function UpdateChecklistPrinted(id) {
//   return CallAPI(
//     `/updateChecklistPrinted/${id}`,
//     {
//       method: "PATCH",
//     },
//     true
//   );
// }


